import React from 'react'
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar'
import Header from '../../Components/Header'
import partnerMail from "../../asset/images/partnermailicon.svg";
import PartnerArroba from "../../asset/images/partnerarroba.svg";
import partnerWebsite from "../../asset/images/partnerwebsite.svg"


function PartnerSideContactUs() {
  const storeToken = localStorage.getItem("ssoToken");

    if(storeToken == null){
        window.location.replace("/")
      }
    return (
        <>
            <Header  portal={"TELECALLER"} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <div className="card-box partner-contact-us">
                    <div className="card-title">
                        <h4 className="h2-css-all">
                            Contact Details for Queries
                        </h4>
                    </div>
                    <div className="card-content">
                        <div className="main-box-width">
                            <div>
                                <ul className="partner-contact-wrapper">
                                    <li>
                                        <div>
                                            <img src={partnerMail} />
                                        </div>
                                        <div className="contact-txt">
                                            <h4>To mail any physical document, write us at :</h4>
                                            <p>Partner Management Team, Bajaj Broking, Unit No 9 &10 First Floor Tower B, Mantri IT Park, Viman Nagar, Pune - 411014, Maharashtra, India</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <img src={PartnerArroba} />
                                        </div>
                                        <div className="contact-txt">
                                            <h4> For any Queries,please reach us</h4>
                                            <p>partner@bajajbroking.in</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <img src={partnerWebsite} />
                                        </div>
                                        <div className="contact-txt">
                                            <h4>Visit Our website at: </h4>
                                            <p>https://www.bajajbroking.in/</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>

            </main>
        </>
    )
}

export default PartnerSideContactUs